import { useFormContext, useWatch } from "react-hook-form";

import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { CAMPAIGN_SLUG_MAX } from "../constants/campaign-slug";
import { CAMPAIGN_LINK_COPY } from "../constants/messages";
import type { CampaignSlugFormValues } from "../hooks/use-campaign-slug-suggestion";

const FIELD_ID = "campaignSlug";
const HELP_ID = "campaignSlug-help";
const ERROR_ID = "campaignSlug-error";

export function CampaignSlugField(): JSX.Element {
  const { control, register, formState } =
    useFormContext<CampaignSlugFormValues>();
  const slug: string = useWatch({ control, name: "slug" }) ?? "";
  const errorMessage: string | undefined = formState.errors.slug?.message;

  const describedBy: string = errorMessage ? `${HELP_ID} ${ERROR_ID}` : HELP_ID;

  return (
    <div>
      <div className="flex items-center justify-between">
        <Label htmlFor={FIELD_ID}>{CAMPAIGN_LINK_COPY.label}</Label>
        <span className="text-xs text-gray-500">
          {slug.length}/{CAMPAIGN_SLUG_MAX}
        </span>
      </div>
      <Input
        id={FIELD_ID}
        placeholder={CAMPAIGN_LINK_COPY.placeholder}
        maxLength={CAMPAIGN_SLUG_MAX}
        autoCapitalize="none"
        spellCheck={false}
        aria-describedby={describedBy}
        aria-invalid={Boolean(errorMessage)}
        {...register("slug")}
      />
      <p id={HELP_ID} className="mt-1 text-xs text-gray-500">
        {CAMPAIGN_LINK_COPY.help}
      </p>
      {errorMessage && (
        <p id={ERROR_ID} className="mt-1 text-sm text-red-500">
          {errorMessage}
        </p>
      )}
    </div>
  );
}
